import styled from "styled-components";

export const Wrap = styled.div`
   display:flex;
   flex-direction:column;
   background:#fff;
  border-radius: 5px;
  padding:30px;
  box-shadow: 0px 4px 8px rgba(138, 107, 118, 0.08);
  }
`;